import { linkifyText } from './linkifyText';
import { isHTML, linkifyHTMLString } from './linkifyHTMLString';

export function linkify(text?: string | null): string {
  if (!text) {
    return '';
  }

  if (isHTML(text)) {
    return linkifyHTMLString(text);
  }

  return linkifyText(text);
}
